<template>
  <el-select :value="options" :placeholder="placeholder" @change="bindChange">
    <el-option v-for="(item,index) in list" :key="index" :label="item[itemValue]" :value="item[itemKey]"
      :disabled="disabled">
    </el-option>
  </el-select>

</template>

<script>
  export default {
    props: {
      name: {
        type: [String, Number],
        required: false,
      },
      placeholder: {
        type: String,
        required: false,
      },
      // 数据数组
      list: {
        required: true,
      },
      // 页面上显示的值
      itemValue: {
        type: String,
        required: true,
      },
      // 传给后台的值再数据中的属性
      itemKey: {
        type: String,
        required: true,
      },
      itemImage: {
        type: String,
        required: false
      },
      itemTime: {
        type: String,
        required: false
      },
      // 传给后台的值
      // value 有可能是 undefined unll 不定义type
      value: {
        required: true,
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        required: false
      },
      color: {
        type: String,
        required: false,
      }
    },
    data() {
      return {
        options: this.value
      }
    },
    watch: {
      value(val, oldVal) {
        this.options = val
      }
    },
    methods: {
      bindChange(e) {
        this.options = e
        this.$emit('input', e)
        this.$emit('change', e)
      }
    },
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ABselect.vue